import { Zalacznik } from '../../wspolne/zalacznik';

export class ImportSrodkowModel {
  idProjektu: string;
  idPomieszczenia: string;
  zalacznik: Zalacznik;
}
